export class KindID {
    public static IMPORT = 1;
    public static EXPORT = 2;
}